<template>
  <div class="flex items-center justify-between w-full h-12 px-5 bg-primary-900 dark:bg-gray-900">
    <div><slot name="left" /></div>
    <div><slot name="right" /></div>
  </div>
</template>
